import React from 'react'
import { Link } from 'react-router-dom'
import Card from './card'
import './styles.css'

export default ({totals}) =>
<div>{totals.map(car=>
	<Card car={car} /> )}
</div>




// WEBPACK FOOTER //
// ./src/components/Home/index.js